<p-dialog modal styleClass="w-[95%] max-w-2xl sm:w-lg" header="Support Request" [(visible)]="visible" (onHide)="closeDialog()">
	<div class="pt-2">
		<app-support-request-form (submitted)="onFormSubmitted()" (cancelled)="closeDialog()"></app-support-request-form>
	</div>
</p-dialog>
